<template>
  <!--  page starting div -->
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
  <div v-else-if="is_no_records == 1">
    <GlobalEmptyRecord RouteName="RecurringInvoiceCreate">
      <template slot="title">
        <h2>Get your Come-Back Period</h2>
      </template>
      <template slot="content">
        <span style="color:gray">Create and send invoices periodically</span>
      </template>
      <template slot="page">New Recurring Invoice</template>
    </GlobalEmptyRecord>
  </div>
  <div class="start-page" v-else style="margin-top:-10px !important">
    <!-- section 1: theader row to declare page headign and to call create page button -->
    <template v-if="CheckedCount == 0">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col cols="8" class="px-0">
          <b-dropdown
            variant="link"
            class="index-filter-heading"
            size="sm"
            dropdown
            toggle-class="text-decoration-none"
            :text="filter_name"
          >
            <div class="dropdownitem-list">
              <b-dropdown-item
                :class="{'filter_dropdown' : true}"
                :to="{ name : 'RecurringInvoice',query: {page: 1 ,show: 10,search:'',status:item.status_id,sort:sort,label:label,custom:custom} }"
                v-for="item in filter_list"
                :key="item.status_id"
                v-if="item.status_name != filter_name"
              >{{ item.status_name }}</b-dropdown-item>
            </div>

            <b-dropdown-divider />
            <router-link
              class="event-link dropdown-item"
              :to="{ name : 'FilterCreate',params : {title :'Recurring Invoice',module:'sales',call:'fetchSalesDetails',type:'recurring_invoice',route:'recurringinvoice'}}"
            >Add Custom Filter</router-link>
          </b-dropdown>
          <router-link
            class="event-link"
            v-if="status >= 100"
            :to="{ name : 'FilterUpdate',params : {id:getPresentValue(filter_list,'status_name',filter_name),title :'Recurring Invoice',module:'sales',call:'fetchSalesDetails',type:'recurring_invoice',route:'recurringinvoice'}}"
          >
            <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
              <i class="la la-edit la-lg"></i>
            </b-button>
          </router-link>
        </b-col>
        <b-col cols="4" class="text-right px-0">
          <router-link
            :to="{ name : 'RecurringInvoiceCreate'}"
            v-if=" RoutePermission(false,'','invoice','recurringinvoice','create')"
          >
            <b-button variant="primary" size="sm" class="mr-2">New Recurring Invoice</b-button>
          </router-link>
           <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()"> <i class="la la-refresh la-lg"></i></b-button>
          <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
            <template slot="button-content">
              <i class="la la-navicon la-lg"></i>
            </template>
            <template v-if="RoutePermission(false,'','','settings','export')">
              <b-dropdown-item @click="exportModal()">
                <span class="no_caret_import la la-download mr-3"></span>Export RecurringInvoice
              </b-dropdown-item>
              <b-dropdown-divider />
            </template>
            <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
            <div class="dropdownitem-block">
              <li class="ml-3">
                <b-form-checkbox name="profile" v-model="profile" value="1">Profile</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="frequency" v-model="frequency" value="1">Frequency</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="sales_person_name"
                  v-model="sales_person_name"
                  value="1"
                >Sales Person</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="total_qty" v-model="total_qty" value="7">Total quantity</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="place_of_supply"
                  v-model="place_of_supply"
                  value="2"
                >Place of Supply</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="rec_start_date" v-model="rec_start_date" value="3">Start Date</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="total_without_tax"
                  v-model="total_without_tax"
                  value="4"
                >Total without Tax</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="inv_tax" v-model="inv_tax" value="5">Total Tax</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="adjusted_amount"
                  v-model="adjusted_amount"
                  value="6"
                >Adjusted Amount</b-form-checkbox>
              </li>

              <li class="ml-3 pt-2">
                <b-form-checkbox
                  name="inv_discount"
                  v-model="inv_discount"
                  value="8"
                >Total Discount Amount</b-form-checkbox>
              </li>
              <li class="ml-3 pt-2">
                <b-form-checkbox name="pjt_name" v-model="pjt_name" value="9">Project</b-form-checkbox>
              </li>
                  <li class="ml-3 pt-2 ">
                <b-form-checkbox name="created_at" v-model="created_at" value="10">Created Time</b-form-checkbox>
              </li>
                <li class="ml-3 pt-2 pb-2">
                <b-form-checkbox name="updated_at" v-model="updated_at" value="11">Updated Time</b-form-checkbox>
              </li>
            </div>
          </b-dropdown>
        </b-col>
      </b-row>
    </template>
    <!-- section 2: to show the search criteria detail  -->
    <b-row>
      <b-col cols="12" class="px-0">
        <!--  section 3:filter dropdown section - to show the saved filter list and daterangepicker to filter -->

        <!-- <h4
          href="#"
          class="float-right"
        >Balance Due : {{orgCurrencySymbol}} {{ isNaN(parseFloat(total_balance_due)) ? 0.00 : parseFloat(total_balance_due).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</h4>-->
        <!--  section 4:show the list of table data form api -->
        <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
          <b-col xl="6" lg="6" md="6" sm="6" xs="6">
            <b-button
              size="sm"
              variant="light"
              class="text-left mr-2"
              @click="changeStatus(1)"
              :disabled="!RoutePermission(false,'','invoice','recurringinvoice','update')"
            >
              <span
                v-b-tooltip="!RoutePermission(false,'','invoice','recurringinvoice','update')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              >Resume</span>
            </b-button>
            <b-button
              size="sm"
              variant="light"
              class="text-left mr-2"
              :disabled="!RoutePermission(false,'','invoice','recurringinvoice','update')"
              @click="changeStatus(3)"
            >
              <span
                v-b-tooltip="!RoutePermission(false,'','invoice','recurringinvoice','update')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              >Stop</span>
            </b-button>
            <!--  delete the selected invoice -->
            <b-button
              size="sm"
              variant="light"
              class="text-left"
              @click="deletemodal"
              :disabled="!RoutePermission(false,'','invoice','recurringinvoice','delete')"
            >
              <i
                class="glyphicon glyphicon-trash"
                v-b-tooltip="!RoutePermission(false,'','invoice','recurringinvoice','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
              ></i>
            </b-button>
          </b-col>
          <b-col xl="6" lg="6" md="6" sm="6" xs="6">
            <i
              v-on:click="checkAll({
                  target :{
                    checked : false
                  }
                
                }),CheckedCount = 0,checkboxes1[0]=false"
              class="la la-times-circle-o cursor_pointer la-lg float-right mar-top-close"
            ></i>
          </b-col>
        </b-row>
        <b-alert
          class="alert-transparent alert-shade mx-mar mt-3"
          :show="this.$route.params.search == '' ? false : true"
        >
          <router-link
            class="text-dark float-right"
            :to="{ name : 'RecurringInvoice',query: {page: page ,show: count,search:'',status:'',sort:sort,label:label,custom:custom} }"
          >
            <i class="la la-remove la-lg text-decoration-none"></i>
          </router-link>
          <p>
            <span
              class="fw-semi-bold"
            >Recurring Invoice No / Customer Name / Customer ID / Profile Name:</span>
            {{ this.$route.query.search }}
          </p>
        </b-alert>

        <div
          :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
          id="scrollCol"
        >
          <table class="table table-hover index-table">
            <thead>
              <tr>
                <th style="width:54px !important">
                  <div class="abc-checkbox index-checkbox text-left">
                    <input
                      type="checkbox"
                      id="checkboxall"
                      v-model="checkboxes1[0]"
                      @change="event => checkAll(event)"
                    />
                    <label for="checkboxall" />
                  </div>
                </th>
                <th style="min-width:85px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'rec_inv_no',custom:custom} }"
                  >
                    ID
                    <small class="text-muted" v-if="label == 'rec_inv_no'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:200px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',custom:custom} }"
                  >
                    Customer
                    <small class="text-muted" v-if="label == 'cus_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:180px !important" v-if="sales_person_name==1">Sales Person</th>
                <th style="min-width:200px !important" v-if="place_of_supply==2">Place of supply</th>
                <th style="min-width:140px !important" v-if="total_qty==7">Quantity</th>
                <th style="min-width:140px !important" v-if="pjt_name==9">Project</th>
                <th style="min-width:120px !important" v-if="profile==1">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'profile_name',custom:custom} }"
                  >
                    Profile
                    <small class="text-muted" v-if="label == 'profile_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:140px !important" v-if="frequency==1">Frequency</th>
                <th style="min-width:140px !important" v-if="rec_start_date==3">Start Date</th>
                <th style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'last_inv_date',custom:custom} }"
                  >
                    Last Invoice
                    <small class="text-muted" v-if="label == 'last_inv_date'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'next_inv_date',custom:custom} }"
                  >
                    Next Invoice
                    <small class="text-muted" v-if="label == 'next_inv_date'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <th style="min-width:110px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'rec_inv_status_name',custom:custom} }"
                  >
                    Status
                    <small class="text-muted" v-if="label == 'rec_inv_status_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th
                  class="text-right"
                  style="min-width:140px !important"
                  v-if="total_without_tax==4"
                >Without Tax</th>
                <th class="text-right" style="min-width:140px !important" v-if="inv_tax==5">Tax</th>
                <th
                  class="text-right"
                  style="min-width:140px !important"
                  v-if="adjusted_amount==6"
                >Adjusted Amt.</th>

                <th
                  class="text-right"
                  style="min-width:140px !important"
                  v-if="inv_discount==8"
                >Discount Amt.</th>
                <th class="text-right" style="min-width:140px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'grand_total',custom:custom} }"
                  >
                    Amount
                    <small class="text-muted" v-if="label == 'grand_total'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                 <th style="min-width:300px !important" v-if="created_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_at',custom:custom} }"
                  >
                    Created Time
                    <small class="text-muted" v-if="label == 'created_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                   <th  style="min-width:300px !important" v-if="updated_at">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'RecurringInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'updated_at',custom:custom} }"
                  >
                    Updated Time
                    <small class="text-muted" v-if="label == 'updated_at'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width:30px !important"></th>

                <!-- <th></th> -->
              </tr>
            </thead>
            <tbody v-if="loading == true">
              <template v-if="lists.length == 0">
                <tr>
                  <td colspan="10" class="text-center">No data to display</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(list,index) in lists" :key="list.rec_inv_hdr_id">
                  <td>
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        v-model="checkboxes1[index + 1]"
                        :id="'checkbox'+(index+1)"
                        :true-value="list.rec_inv_hdr_id"
                        :value="list.rec_inv_hdr_id"
                        @change="event => changeCheck(event, 'checkboxes1', index+1)"
                      />
                      <label :for="'checkbox'+(index+1)" />
                    </div>
                  </td>
                  <td
                    v-if="RoutePermission(false,'','invoice','recurringinvoice','index')"
                    class="text-nowrap"
                  >
                    <router-link
                      class="event-link theme-text-color"
                      :to="{ name : 'RecurringInvoiceView',params:{id:list.rec_inv_hdr_id }}"
                    >{{ list.rec_inv_no }}</router-link>
                  </td>
                  <td v-else class="theme-text-color text-nowrap">{{ list.rec_inv_no }}</td>
                  <td style="max-width:200px !important">
                    <span class="text">{{ list.cus_name }}</span>
                  </td>
                  <td style="width:180px !important" v-if="sales_person_name==1">
                    <span class="text">{{list.sales_person_name}}</span>
                  </td>
                  <td
                    v-if="place_of_supply==2"
                  >{{ getDetails($AppDetails.state_details,list.place_of_supply,'state_name')}}</td>

                  <td
                    v-if="total_qty==7"
                  >{{ parseFloat(list.total_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>

                  <td style="width:140px !important" v-if="pjt_name==9">
                    <span class="text">{{list.pjt_name}}</span>
                  </td>
                  <td v-if="profile==1" style="width:180px !important">
                    <span class="text">{{ list.profile_name }}</span>
                  </td>

                  <td v-if="frequency==1" class="text-nowrap">{{ list.frequency }}</td>
                  <td v-if="rec_start_date==3">{{getDateFormat(list.rec_start_date)}}</td>
                  <td v-if="RoutePermission(false,'','invoice','recurringinvoice','update')">
                    <router-link
                      class="event-link theme-text-color"
                      :to="{ name : 'RecurringInvoiceUpdate',params:{id:list.rec_inv_hdr_id}}"
                    >{{ getDateFormat(list.last_inv_date) }}</router-link>
                  </td>
                  <td v-else>{{ getDateFormat(list.last_inv_date) }}</td>

                  <td
                    v-if="RoutePermission(false,'','invoice','recurringinvoice','index')"
                    class="text-nowrap"
                  >
                    <router-link
                      class="event-link theme-text-color"
                      :to="{ name : 'RecurringInvoiceView',params:{id:list.rec_inv_hdr_id},query:{next_inv:true} }"
                    >{{ getDateFormat(list.next_inv_date) }}</router-link>
                  </td>
                  <td
                    v-else
                    class="theme-text-color text-nowrap"
                  >{{ getDateFormat(list.next_inv_date) }}</td>
                  <td>{{ list.rec_inv_status_name }}</td>
                  <td class="text-right" v-if="total_without_tax==4">
                    {{getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+ parseFloat(list.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right" v-if="inv_tax==5">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.inv_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right" v-if="adjusted_amount==6">
                    {{getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+ parseFloat(list.adjusted_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>

                  <td class="text-right" v-if="inv_discount==8">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.inv_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                  <td class="text-right">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.cus_currency,
                    "currency_symbol"
                    )+" "+parseFloat(list.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                    <td v-if="created_at">
                      <span class="text">
                      {{ displayDateTime(list.created_at) }}
                      </span>
                      </td>
                    <td v-if="updated_at" >
                         <span class="text">
                      {{ displayDateTime(list.updated_at) }}
                         </span>
                  </td>
                  <td class="text-right">
                    <b-dropdown
                      right
                      toggle-class="text-decoration-none"
                      variant="link"
                      no-caret
                      size="xs"
                      class="table-hover-visible last-td-arrow"
                      v-if="RoutePermission(false,'','invoice','recurringinvoice','delete')||RoutePermission(false,'','invoice','recurringinvoice','update')"
                    >
                      <template slot="button-content">
                        <i
                          class="glyphicon glyphicon-option-vertical theme-text-color"
                          style="top:-6px !important;letter-spacing:-5px !important"
                        ></i>
                      </template>
                      <router-link
                        v-if="RoutePermission(false,'','invoice','recurringinvoice','update')"
                        class="event-link dropdown-item"
                        :to="{ name : 'RecurringInvoiceUpdate',params:{id:list.rec_inv_hdr_id}}"
                      >Edit</router-link>

                      <router-link
                        v-if="RoutePermission(false,'','invoice','recurringinvoice','create')"
                        class="event-link dropdown-item"
                        :to="{ name : 'RecurringInvoiceCreate',query:{clone_id:list.rec_inv_hdr_id}}"
                      >Clone</router-link>
                    </b-dropdown>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>Loading...</tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <!--  section 5:pagination detail of the table -->
    <b-row
      v-if="lists.length > 0"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }} of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                size="xs"
                toggle-class="text-decoration-none"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'RecurringInvoice',query: {page: 1,show: 10,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'RecurringInvoice',query: {page: 1,show: 25,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'RecurringInvoice',query: {page: 1 ,show: 50,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#scrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#scrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template
          v-if="show<total_count"
          style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
        >
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RecurringInvoice',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'RecurringInvoice',query: {page: 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RecurringInvoice',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RecurringInvoice',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'RecurringInvoice',query: {page: Math.ceil(total_count / count),show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RecurringInvoice',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>

    <b-modal
      id="invoiceupdate"
      size="md"
      body-class="bg-white"
      cancel-title="cancel"
      cancel-variant="light"
      ok-title="Update"
      title="Bulk Update-Recurring Invoice"
    >
      <p>Choose a field from the dropdown and update with new information.</p>
      <b-row>
        <b-col>
          <b-form-group>
            <select
              name="update"
              class="form-control text-right"
              style="padding:2px;background: #f7f7f7;"
              placeholder="Select a field"
            >
              <option value="0"></option>
              <option value="1">Reference#</option>
              <option value="1">PDF template</option>
              <option value="2">Sales person</option>
              <option value="4">Invoice date</option>
              <option value="4">Payment Terms</option>
              <option value="4">Payment Gateways</option>
              <option value="3">Customer Notes</option>
              <option value="4">Terms and conditions</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col style="max-width:500px">
          <b-form-input type="text" size="sm" name="type" />
        </b-col>
      </b-row>
      <span>Note: All the selected invoices will be updated with new information and you cannot undo this.</span>
    </b-modal>
    <!--  bulk delete modal -->
    <DeleteRecord
      v-on:setDelete="getDelete"
      :value="value"
      module="recurringinvoice"
      content="The selected recurring invoice(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
    ></DeleteRecord>
    <LogRecord :message="logrecords"></LogRecord>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Recurring Invoice'"
      @downloaded="export_modal=false"
    />
  </div>
  </div>
</template>

<script>
// import needed functions, file , components and state
import { mapState, mapGetters } from "vuex";
import store from "@/store/index"; // to call all vuex state
import { notificationMixin } from "@/mixins/notification"; // notification is a global function to show notification success/error alert
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import $ from "jquery";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
// function to done before route enter and before route update
function getPageInvoice(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1; // current page
  const show = parseInt(routeTo.query.show) || 10; // count per page
  const search = routeTo.query.search || ""; // search details
  const status = routeTo.query.status || store.state.recurringinvoice.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";

  // get the list of data as per the requirements
  store
    .dispatch("recurringinvoice/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      else {
        store.dispatch("sales/fetchSalesDetails");
      }

      // store all the query details in route params
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, formatDate, scrollTable], // register all your global function here to access as normal methods
  props: {
    // all your property
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "RecurringInvoice", // name of the route
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        ID: "rec_inv_no",
        Customer: "cus_name",
        "Sales Person": "sales_person_name",
        "Total Quantity": "total_qty",
        Project: "pjt_name",
        Profile: "profile_name",
        Frequency: "frequency",
        "Start Date": "rec_start_date",
        "Last Invoice": "last_inv_date",
        "Next Invoice": "next_inv_date",
        Status: "rec_inv_status_name",
        "Without Tax(BCY)": "total_without_tax",
        "Without Tax(FCY)": "export_total_without_tax",
        "Tax(BCY)": "inv_tax",
        "Tax(FCY)": "export_inv_tax",
        "Adjusted Amount(BCY)": "adjusted_amount",
        "Adjusted Amount(FCY)": "export_adjusted_amount",
        "Discount Amount(BCY)": "inv_discount",
        "Discount Amount(FCY)": "export_inv_discount",
        "Amount(BCY)": "grand_total",
        "Amount(FCY)": "export_grand_total",
        "Created Time":"created_at",
        "Updated Time":"updated_at"
      },
      profile: "",
      frequency: "",
      sales_person_name: "",
      place_of_supply: "",
      total_qty: "",
      created_at:"",
      updated_at:"",
      rec_start_date: "",
      total_without_tax: "",
      inv_tax: "",
      adjusted_amount: "",
      inv_discount: "",
      pjt_name: "",
      logrecords: "", // to show log of popup funcitons
      value: [],

      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // success alert notification class
      showDismissibleAlert: this.$route.query.search == "" ? false : true, // search criteria
      loading: true, // loader option
      total: 10, // total page to show
      checkboxes1: [],
      check_index: [],
      CheckedCount: 0
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
      //refresh List
    getrefreshList(){
    var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
       const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
       store
    .dispatch("recurringinvoice/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
        .then(()=>{
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          })
        });
    },
    changeStatus(id) {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);

      store
        .dispatch("recurringinvoice/bulkstoprecurring", {
          id: ids,
          rec_inv_status: id
        })
        .then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.status,
            type: response.data.type,
            showCloseButton: true
          });
          var page = this.page;
          var page_show = this.show;
          const currentPage = page;
          const show = page_show;
          const search = this.$route.query.search || "";
          const status = this.$route.query.status || "";
          const update = this.$route.query.update;
          const label = this.$route.query.label || "";
          const sort = this.$route.query.sort || "";
          const update_status = update == true ? false : true;

          this.$router
            .push({
              name: this.$route.name,
              query: {
                page: currentPage,
                show: show,
                search: search,
                status: status,
                update: update_status,
                sort: sort,
                label: label
              }
            })
            .then(async () => {
              this.page = await (this.lists.length == 0 && this.page != 1
                ? (this.page = 1)
                : this.page);
              this.$route.params.sort = sort;
              this.$router.push({
                name: this.$route.name,
                query: {
                  page: this.page,
                  show: show,
                  search: search,
                  status: status,
                  update: update_status,
                  sort: sort,
                  label: label
                }
              });
            });
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("recurringinvoice/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
          this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
        });
      return response;
    },

    //  detelted record details
    getDelete() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("recurringinvoice/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);
          this.$route.params.sort = sort;
          this.$router.push({
            name: this.$route.name,
            query: {
              page: this.page,
              show: show,
              search: search,
              status: status,
              update: update_status,
              sort: sort,
              label: label
            }
          });
        });
       if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;

      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.rec_inv_hdr_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var rec_inv_hdr_ids = this.checkboxes1;
      rec_inv_hdr_ids = rec_inv_hdr_ids.filter(item => item !== false);
      // check all if page length matches
      if (rec_inv_hdr_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },

    // to filter the json data - to get any particular data from json
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    }
  },
  // called synchronously after the vue instance created
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    // to get the messenger notification in pretty format
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    if (this.error == 500) {
      window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message: "No internet connection.Please try after some time",
        type: "danger",
        showCloseButton: true
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
     store.state.recurringinvoice.index_status=store.state.settings.status_code!=404? store.state.recurringinvoice.index_status:""
    store.dispatch(
      "sales/fetchSalesDetails",
      JSON.stringify({
        type: "recurring_invoice",
        page: "filterdetails"
      })
    );
    getPageInvoice(routeTo, next); // function will be called before route enter ( to get all the api datas before page loading)
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
      store.state.recurringinvoice.index_status = "";
    getPageInvoice(routeTo, next); // function will be called before route update ( to get all the api datas before page loading)
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
   beforeRouteLeave(to, from, next) {
    store.state.recurringinvoice.recurringinvoice_index_history = from.fullPath;
    store.state.recurringinvoice.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },

  computed: {
    ...mapState({
      lists: state => state.recurringinvoice.lists, // to show the data inside the table file: invoice.js
      total_count: state => state.recurringinvoice.total_count, // to show the total count of the data inside the table file: invoice.js
      is_no_records: state => state.recurringinvoice.is_no_records, // to check for an record in the database
      total_balance_due: state => state.recurringinvoice.total_balance_due, // to show the total balance due of the data inside the table file: invoice.js
      count: state => state.recurringinvoice.count, // to show the  counts of the data inside the table file: invoice.js
      search_criteria: state => state.recurringinvoice.search_criteria, // to show the  search criteria name inside the table file: invoice.js
      filter_list: state => state.recurringinvoice.filter_list, // to show the  dropdown of filter list name inside the table file: invoice.js
      filter_name: state => state.recurringinvoice.filter_name, // to show the  name of the selected filter list name inside the table file: invoice.js
      error: state => state.recurringinvoice.error, // to show the  if any error occured in api file: invoice.js
      message: state => state.recurringinvoice.log_details,
      export: state => state.recurringinvoice.export,
      status_code: (state) => state.recurringinvoice.status_code,
      status_message: (state) => state.recurringinvoice.status_message,
      status_type: (state) => state.recurringinvoice.status_type,
    }),
    ...mapGetters(["orgCurrencySymbol"])
  }
};
</script>


